module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ID":"ID","created":"Created","size":"Size","status":"Status","message":"Message","{vm} backups":"{vm} backups"},"de":{"ID":"ID","created":"angelegt","size":"Grösse","status":"Status","message":"Meldung","{vm} backups":"{vm} Backups"}}')
  delete Component.options._Ctor
}
